import { render } from "./FightResult.vue?vue&type=template&id=2c257985"
import script from "./FightResult.vue?vue&type=script&lang=js"
export * from "./FightResult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__